import { render, staticRenderFns } from "./integralPeopleItemAudit.vue?vue&type=template&id=3bd53b0e&scoped=true&"
import script from "./integralPeopleItemAudit.vue?vue&type=script&lang=js&"
export * from "./integralPeopleItemAudit.vue?vue&type=script&lang=js&"
import style0 from "./integralPeopleItemAudit.vue?vue&type=style&index=0&id=3bd53b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd53b0e",
  null
  
)

export default component.exports